<div class="splash-screen">
  <div class="agent">
    <svg-icon icon="agent-head"></svg-icon>
  </div>

  <div class="dotted"></div>

  <div class="downward-arrow">
    <svg-icon icon="arrow-down"></svg-icon>
  </div>

  <div class="dotted"></div>

  <div class="assisted-browsing-icon">
    <svg-icon icon="assisted-browsing-inactive"></svg-icon>
  </div>

  <div class="instructions">
    <div>{{ 'bcAssistedBrowsingPanel.waitingForPermission' | translate }}</div>
  </div>
</div>
